export default (value) => {
    return [
        'light',
        'dark',
    ].indexOf(value) !== -1;
};
